module.exports = {
      id: "success-usage",
      viewBox: "0 0 82 82",
      url: __webpack_public_path__ + "svg-sprite-c58a3b4628aec4c6d4a5f4fa9a2e0307.svg#success",
      toString: function () {
        return this.url;
      }
    }